import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox';
import Swiper, { Navigation, Pagination } from 'swiper';

// import mapBox from './inc/hmMaps';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded';
// import InfiniteScroll from 'infinite-scroll';

import lottie from 'lottie-web';
import animationData from './inc/lottie.json';
// import heartAnimationData from './inc/lottie-heart.json';

import {
    parallaxObject,
    parallaxScroll
} from './inc/parallaxScroll';

import dataStore from './inc/dataStore';
import { herrlichesMenu, mobileSubmenu, hmNavInit } from './inc/header';
import browserDetection from './inc/browserDetection';
import observeIntersection from './inc/observeIntersection';
// import scriptLoader from './inc/scriptLoader';
import devAt from './inc/devAt';

jQueryBridget('masonry', Masonry, $);
jQueryBridget('imagesLoaded', imagesLoaded, $);
// const Mustache = require('mustache');

Swiper.use([Navigation, Pagination]);

const LazyLoad = require('vanilla-lazyload');

window.jQuery = jQuery;
window.$ = jQuery;

/* Author: herrlich media */
$(document).ready(() => {
    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Ready Inits +++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    /* browser/touch detection ++++++++++++++++++++++++++++++++++++++++++*/
    browserDetection();

    if ($('.map').length && window.BorlabsCookie.checkCookieConsent('googlemaps') === true) {
        $('.map').each((i, el) => {
            render_map($(el));
        });
    }

    window.addEventListener('loadGMap', () => {
        // console.log('loadGMap');
        if ($('.map').length && window.BorlabsCookie.checkCookieConsent('googlemaps') === true) {
            setTimeout(() => {
                // console.log('loadGMap hier');
                $('.map').each((i, el) => {
                    render_map($(el));
                });
            }, 1000);
        }
    }, false);

    if ($('.animationWrapper').length) {
        // console.log('starte animation');
        dataStore.hasAnim = true;

        const id = $('.animationWrapper').attr('id');

        dataStore.anim = lottie.loadAnimation({
            container: document.getElementById(id),
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData
        });

        // console.log(dataStore.anim);
    }

    $('.scrollBtn').on('click', (e) => {
        const section = $(e.currentTarget).closest('section');
        const { top } = section.offset();
        const height = section.height();

        $('html, body').animate({
            scrollTop: top + height
        }, 500);
    });

    // if ($('.addToList').length) {
    //     addToListIconAnimation();
    // }

    checkSticky();

    /* Masonry  ++++++++++++++++++++++++++++++++++++++++++*/
    dataStore.$container.imagesLoaded(() => {
        masonryUpdate();
    });

    /* Zurück zur Produktübersicht  ++++++++++++++++++++++++++++++++++++++++++*/
    $('#goBack').click((e) => {
        e.preventDefault();
        window.history.back();
    });

    $('.checkOnList').each((a, el) => {
        const id = $(el).data('postid');
        const listObj = JSON.parse(dataStore.watchlistItems);

        if (listObj !== null && listObj.items.length) {
            for (let i = 0; i < listObj.items.length; i++) {
                if (listObj.items[i].postID === id) {
                    $(el).addClass('inList');
                    break;
                }
            }
        }
    });

    /* Youtube Video  ++++++++++++++++++++++++++++++++++++++++++*/
    /* eslint-disable */
    $(document).on({
        mouseenter: (e) => {
            $('#videoTooltip').removeClass('vis');
            if (window.BorlabsCookie.checkCookieConsent('youtube') === true) {
                $('#videoTooltip .video-container').html('<div id="player"></div>');
                dataStore.vidLink = $(e.currentTarget).find('.videoPreview').attr('data-vid');
            
                if(dataStore.vidLink !== undefined){
                    setTimeout(() => {

                        dataStore.player = new YT.Player('player', {
                            playerVars: {
                                'autoplay': 1,
                                'controls': 0,
                                'autohide': 1,
                                'wmode': 'opaque',
                                'showinfo': 0,
                                'loop': 1,
                                'mute': 1,
                                'playlist': dataStore.vidLink
                            },
                            videoId: dataStore.vidLink,

                        });

                        function onPlayerReady(event) {
                            event.target.mute();
                            //why this? Well, if you want to overlay text on top of your video, you
                            //will have to fade it in once your video has loaded in order for this
                            //to work in Safari, or your will get an origin error.
                        }

                        dataStore.vidWrap.addClass('vis');
                    }, 300);

                    window.onmousemove = function (e) {
                        dataStore.x = e.clientX;
                        dataStore.y = e.clientY;

                        dataStore.vidWrap.css({
                            'top' : (dataStore.y + 20) + 'px',
                            'left' : (dataStore.x + 20) + 'px'
                        });

                    };
                    dataStore.hoverOnVid = true;
                }
            }
        },
        mouseleave: function(){
            $('#videoTooltip').removeClass('vis');

            setTimeout(function() {
                $('#videoTooltip .video-container').html('<div id="player"></div>');
            },300);

        }
    }, '.postItem');
    /* eslint-enable */

    /* Intersection Observer  ++++++++++++++++++++++++++++++++++++++++++*/
    observeIntersection('.fadeIn', (isIntersecting, e) => {
        if (isIntersecting) {
            $(e.target).not('.vis').addClass('vis');
        }
    }, true);

    observeIntersection('.fadeInRow', (isIntersecting, e) => {
        if (isIntersecting) {
            // console.log('fadeInRow');
            $(e.target)
                .find('> div, > li, > p, > span, > h1, > a')
                .not('.vis')
                .each((i, el) => {
                    setTimeout(() => {
                        $(el).addClass('vis');
                    }, 150 * i);
                });
        }
    }, true);

    observeIntersection('.journeyItem .circle', (isIntersecting, e) => {
        if (isIntersecting) {
            const parent = $(e.target).closest('.journeyItem');
            parent.addClass('active').addClass('current');
            const index = parent.index();
            $('.cjImg').eq(index).addClass('fixed');
        } else {
            const parent = $(e.target).closest('.journeyItem');
            parent.removeClass('active');
            const index = parent.index();
            $('.cjImg').eq(index).removeClass('fixed');
        }
    }, false, 0, undefined, '0% 0% -50% 0%');

    // observeIntersection('.animationWrapper', (isIntersecting) => {
    //     if (isIntersecting) {
    //         dataStore.hasAnim = true;
    //         dataStore.anim = lottie.loadAnimation({
    //             container: document.getElementById('lottieblock_62cd1d3f04677'),
    //             renderer: 'svg',
    //             loop: false,
    //             autoplay: false,
    //             animationData
    //         });
    //     }
    // }, false, 0, undefined, '0% 0% -50% 0%');

    /* Herrlich Media Nav Init ++++++++++++++++++++++++++++++++++++++++++*/
    hmNavInit();

    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Plugins +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    /* lazy load  ++++++++++++++++++++++++++++++++++++++++++*/
    lazyloadUpdate();

    // Back to Top Button
    // if (dataStore.backToTop.length) {
    //     dataStore.hasBackToTop = true;
    //     dataStore.scrollWrapTop = dataStore.scrollWrap.offset().top;
    //     dataStore.filterBarHeight = dataStore.filterBar.height();
    //     dataStore.backToTop.click(() => {
    //         dataStore.body.animate({
    //             scrollTop: dataStore.scrollWrapTop - dataStore.header.height()
    //         }, 500);
    //     });
    // }

    /* Ffancybox  ++++++++++++++++++++++++++++++++++++++++++*/
    Fancybox.bind(
        '.wp-block-gallery a[href$=jpg], .wp-block-gallery a[href$=png], .wp-block-gallery a[href$=webp]',
        {
            groupAll: true,
        }
    );

    Fancybox.bind(
        '.wp-block-image a[href$=jpg], .wp-block-image a[href$=png], .wp-block-image a[href$=webp]'
    );

    Fancybox.bind('.merchantTrigger', {
        type: 'inline',
        mainClass: 'merchantFancyBox'
    });

    /* Formular ++++++++++++++++++++++++++++++++++++++++++*/
    $('.field input,.field select, .field textarea').focus(() => {
        const input = $(this);
        const formField = input.closest('.field');

        formField.addClass('input--filled');
    }).focusout(() => {
        const input = $(this);
        const formField = input.closest('.field');

        if (!input.val()) {
            formField.removeClass('input--filled');
        }
    });

    // ######################################
    // ######### Products Table Ajax #########
    // ######################################

    if (parseInt(window.wp_urls.pageID, 10) === dataStore.globalIds.b2bShop
    || parseInt(window.wp_urls.pageID, 10) === dataStore.globalIds.b2bCart) {
        dataStore.isB2B = true;
    }

    if (dataStore.isB2B || dataStore.productListLocation === 'singleProduct'
    || dataStore.productListLocation === 'b2bCart') {
        getNonce();
    } else if (dataStore.productListLocation === 'watchList' || dataStore.productListLocation === 'productsArchive') {
        getJsonProducts(dataStore.productsTableTerm);
    } else {
        dataStore.discount = 0;
    }

    // ########   Product Cats Event Listener   ########

    // Get Cat Slug on Click
    $('#catFilter .toggleTitle').on('click', (e) => {
        if ($(e.currentTarget).parent().hasClass('inactive')) {
            const filterCat = $(e.currentTarget).parent().data('cat');
            productsTableClick(filterCat);
            // eslint-disable-next-line
            history.replaceState(null, null, `#${filterCat}`);
        }

        if (!$(e.currentTarget).parent().hasClass('inactive')) {
            // eslint-disable-next-line
            history.pushState('', document.title, window.location.pathname);
            $(e.currentTarget).siblings('.subCats').find('li').addClass('inactive')
                .siblings('.toggleAll')
                .removeClass('inactive');
        }

        const notCurrent = $('.toggleTitle').not(e.currentTarget).parent();

        notCurrent.find('.subCats').slideUp();
        notCurrent.addClass('inactive')
            .find('.subCats li')
            .addClass('inactive')
            .siblings('.toggleAll')
            .removeClass('inactive');

        $(e.currentTarget).parent().toggleClass('inactive').find('.subCats')
            .slideToggle();

        checkSticky();
    });

    // Get Cat Slug on Click
    $('#catFilter .subCats li').on('click', (e) => {
        // $('.subCats li').not(this).addClass('inactive');
        $(e.currentTarget).parent().find('li').not(e.currentTarget)
            .addClass('inactive');

        $(e.currentTarget).removeClass('inactive');

        let filterCat;

        if ($(e.currentTarget).hasClass('toggleAll')) {
            filterCat = $(e.currentTarget).parent().parent().data('cat');
        } else {
            filterCat = $(e.currentTarget).data('cat');
        }
        productsTableClick(filterCat);
        // eslint-disable-next-line
        history.replaceState(null, null, `#${filterCat}`);
    });

    // get products by hash
    if ($('.page-template-template-b2b_order_table, .post-type-archive-products').length) {
        const productHash = window.location.hash.substr(1);
        // eslint-disable-next-line
        const productSlug = '';
        let productMenuEl = '';
        let productHashArray = [];

        if (productHash.indexOf('/') > -1) {
            productHashArray = productHash.split('/');
            productMenuEl = $(`li[data-cat="${productHashArray[0]}"]`);
            // eslint-disable-next-line
            dataStore.productsTableProductHashSlug = productHashArray[1];

            /* eslint-disable */
            $.getJSON(`${window.wp_urls.baseUrl}/wp-json/wp/v2/products?slug=${dataStore.productsTableProductHashSlug}`, function (data) {
                getAjaxData(data[0].id);
            });
            /* eslint-enable */
        } else {
            productMenuEl = $(`li[data-cat="${productHash}"]`);
        }

        if (productMenuEl.length) {
            if (productMenuEl.hasClass('mainCat')) {
                productMenuEl.find('.toggleTitle').trigger('click');
            } else {
                productMenuEl.trigger('click');
            }
            if (productMenuEl.parent().hasClass('subCats')) {
                productMenuEl.parent().slideDown();
                productMenuEl.parent().parent().removeClass('inactive');
            }
        }
    }

    // Zur Kasse Btn
    $('.checkoutBtn').on('click touch', (e) => {
        $(e.currentTarget).fadeOut(150);
        const billingAdress = $('.billing_address_container');
        billingAdress.slideDown(300, 'swing');
        dataStore.body.stop().animate({ scrollTop: billingAdress.offset().top - 50 }, 300, 'swing');
    });

    // merklisten count setzen
    updateWatchListBtn();
    updateCartBtn();

    // btn klassen setzen
    setButtonClasses();

    // Add to List Eventlistener
    $(document).on('click', '.addToList', (e) => {
        // daten in temporäres objekt packen
        const thisLink = $(e.currentTarget);
        const tempObject = {
            postID: thisLink.data('postid'),
            postTitle: thisLink.data('posttitle'),
            postNr: thisLink.data('postartnr'),
            preorder: thisLink.closest('.postItem').data('preorder')
        };

        let obj;
        const currentObj = JSON.parse(dataStore.watchlistItems);
        if (!thisLink.hasClass('inList')) {
            if (currentObj != null) { // wenn bereits daten im local storage waren
                obj = currentObj;
                obj.items.push(tempObject);
            } else { // noch keine Daten vorhanden
                obj = {
                    items: []
                };
                obj.items.push(tempObject);
            }
            thisLink.addClass('inList');
        } else {
            // eslint-disable-next-line
            obj = removeFromWatchList(currentObj,tempObject.postID);
            thisLink.removeClass('inList');
        }
        // eslint-disable-next-line
        setStroageVal(obj);
        updateWatchListBtn();
    });

    // Add to Cart Eventlistener
    $(document).on('click', '.addToCart', (e) => {
        // daten in temporäres objekt packen
        const setId = $(e.currentTarget).closest('.postItem').attr('data-setid');

        if (setId.length === 0) {
            addToCart(e.currentTarget);
        } else {
            // console.log('item from set');
            // eslint-disable-next-line
            console.log($(e.currentTarget));
            // eslint-disable-next-line
            const val = parseInt($(e.currentTarget).parent().find('.ui-spinner input').val());
            // eslint-disable-next-line
            const thisLink = $(e.currentTarget);

            // console.log('setId', setId);
            // console.log('val', val);

            let obj;

            // PREORDER
            let hash = '';
            if (window.location.hash) {
                hash = window.location.hash.substr(1);
            }

            // console.log('hash', hash);

            $.getJSON(`${window.wp_urls.baseUrl}/wp-json/wp/v2/products?set-id=${setId}&per_page=100`, (data) => {
                $(data).each((key, value) => {
                    console.log(value);
                    const tempObject = {
                        postID: value.id,
                        postTitle: value.title.rendered,
                        postNr: value.acf.artnr,
                        quantity: val,
                        preorder: 0
                    };

                    if (hash === 'preorder' || value.acf.preorder === 1) {
                        tempObject.preorder = value.acf.preorder;
                    }

                    const currentObj = JSON.parse(dataStore.cartItems);

                    if (currentObj != null) {
                        // wenn bereits daten im local storage waren
                        // vorhandenes Produkt hochzähöen
                        const found = false;
                        for (let a = 0, aLen = currentObj.items.length; a < aLen; a++) {
                            if (currentObj.items[a].postID === tempObject.postID
                                && currentObj.items[a].preorder === tempObject.preorder) {
                                currentObj.items[a].quantity += tempObject.quantity;
                                // eslint-disable-next-line
                                found = true;
                                break;
                            }
                        }

                        obj = currentObj;
                        if (!found) {
                            obj.items.push(tempObject);
                        }
                    } else { // noch keine Daten vorhanden
                        obj = {
                            items: []
                        };
                        obj.items.push(tempObject);
                    }

                    // Max Value neu setzen
                    // eslint-disable-next-line
                    $(`input[data-artnr="${value.acf.artnr}"]`).attr('max', parseInt($(`input[data-artnr="${value.acf.artnr}"]`).attr('max'))-val);
                    // eslint-disable-next-line
                    setCartVal(obj);
                    updateCartBtn();
                });
            });
        }
    });

    //  Remove Item from Watchlist
    $(document).on('click', '.removeFromWatchList, .removeFromCart', (e) => {
        e.preventDefault();
        // Produkte aus Merkliste entfernen
        const setId = $(e.currentTarget).closest('.postItem').attr('data-setid');

        if ($(e.currentTarget).hasClass('removeFromWatchList') || setId.length === 0) {
            manageRemoveList(e.currentTarget);
        } else {
            const setItems = $(`.postItem[data-setid=${setId}]`);
            const itemCollection = [];

            for (let a = 0, aLen = setItems.length; a < aLen; a++) {
                itemCollection.push($(setItems[a]).find('.removeFromCart'));
            }

            for (let i = 0, iLen = itemCollection.length; i < iLen; i++) {
                manageRemoveList(itemCollection[i]);
            }
        }
    });

    // Add Watchlist Items to Cart Items
    const currentWatchList = JSON.parse(dataStore.watchlistItems);
    if (currentWatchList != null && !isEmpty(currentWatchList.items)) {
        $('#watchListToCart').removeClass('hide');
        $('#watchListToCart .btn').on('click', () => {
            let bestand = 1;
            $.each(currentWatchList.items, (index, value) => {
                bestand = $(`[data-postid=${value.postID}]`).attr('data-bestand');
                addToCart(false, value, bestand);
            });

            $('.removeFromWatchList').trigger('click');
        });
    }

    /* products Table ++++++++++++++++++++++++++++++++++++++++++*/
    if (dataStore.productsTable.length) {
        if (dataStore.fitlerCats.length) {
            //---------------- daten von url holen ----------------
            const sPageURL = decodeURIComponent(window.location.search.substring(1));
            if (sPageURL !== '') {
                const sURLVariables = sPageURL.split('=');
                const selectedArr = sURLVariables[1].split(',');

                for (let a = 0; a < selectedArr.length; a++) {
                    dataStore.selectedCats.push(selectedArr[a]);
                }
            }
        }

        // Start Product Filter on Search Key down
        $('#search').on('keyup', () => {
            clearTimeout(dataStore.endOfType);
            dataStore.endOfType = setTimeout(() => {
                if ($('#search').val().length > 3) {
                    dataStore.productsTableSearch = $('#search').val();
                } else {
                    dataStore.productsTableSearch = false;
                }
                productsTableClick();
            }, 500);
        });
    }

    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Scroll ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    $(window).scroll(() => {
        dataStore.docScroll = $(window).scrollTop();

        dataStore.header.toggleClass('fix', dataStore.docScroll > 100);
        dataStore.scrollnav.toggleClass('fix', dataStore.docScroll > 100);

        // Parallax Scroll
        parallaxScroll();

        animatebodymovin();
        // back to top
        // if (dataStore.hasBackToTop) {
        //     dataStore.backToTop.toggleClass('vis', dataStore.docScroll
        //     > (dataStore.scrollWrapTop + (dataStore.filterBarHeight / 4)));
        // }

        //++++++++++++++++++++++++ Product Table Infitie Scroll +++++++++++++++++++++++++++++
        if (dataStore.productListLocation !== 'singleProduct' && dataStore.productsTableLength && (dataStore.docScroll
            + dataStore.winHeight) >= (dataStore.productsTableOffsetTop + dataStore.productsTableHeight - 750)
            && dataStore.productsTableEnd === false) {
            getJsonProducts(dataStore.productsTableTerm);
        }
    });
}); /* ready end ++++++++++++++++++++++++++++++++++++++++++*/

$(window).resize(() => {
    dataStore.docWidth = $(document).width();
    dataStore.docHeight = $(document).height();
    dataStore.winHeight = $(window).height();

    $(window).trigger('scroll');

    // if (dataStore.hasBackToTop) {
    //     dataStore.scrollWrapTop = dataStore.scrollWrap.offset().top;
    //     dataStore.filterBarHeight = dataStore.filterBar.height();
    // }

    clearTimeout(dataStore.endOfResize);
    dataStore.endOfResize = setTimeout(() => {
        afterResize();
    }, 250);
});

function afterResize() {
    mobileSubmenu();
    herrlichesMenu.destroy();
    herrlichesMenu.init();

    // Parallax Object after ajax
    parallaxObject();

    checkSticky();
    masonryUpdate();
}

$(window).on('load', () => {
    /* Swiper  ++++++++++++++++++++++++++++++++++++++++++*/
    new Swiper('.headerSlider', {
        // Optional parameters
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    $('.produktTeaser').each((i, el) => {
        const parentId = $(el).attr('id');

        const produktTeaserSwiper = new Swiper(`#${parentId} .productSwiper`, {
            slidesPerView: 1,
            loop: false,
            centeredSlides: false,
            autoHeight: true,
            navigation: {
                nextEl: `#${parentId} .swiper-button-next`,
                prevEl: `#${parentId} .swiper-button-prev`,
            },
            on: {
                init: () => {
                    lazyloadUpdate();
                }
            }
        });

        produktTeaserSwiper.on('slideChange', () => {
            lazyloadUpdate();
        });
    });

    /* developed at ++++++++++++++++++++++++++++++++++++++++++*/
    devAt();
});

// Lazyload Update
const lazyloadUpdate = function lazyloadUpdate() {
    if (dataStore.lazyLoadInstance !== '') {
        dataStore.lazyLoadInstance.update();
    }

    // Parallax Object after ajax
    parallaxObject();
};

const masonryUpdate = function masonryUpdate() {
    if (dataStore.$container.length) {
        dataStore.$container.masonry({
            itemSelector: '.item',
            stamp: '.stamp'
        });
    }
};

/* Webp Support Detection  ++++++++++++++++++++++++++++++++++++++++++*/
async function supportsWebp() {
    if (!window.self.createImageBitmap) return false;

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    // eslint-disable-next-line
    const blob = await fetch(webpData).then((r) => r.blob());
    return createImageBitmap(blob).then(() => true, () => false);
}

// Add Webp to Background Imgaes when supported
(async() => {
    if (await supportsWebp()) {
        dataStore.body.addClass('webp');
        const lazyBg = document.querySelectorAll('[data-bg]');
        lazyBg.forEach((element) => {
            let { bg } = element.dataset;
            if (bg.match(new RegExp('.*(.jpg|.jpeg|.png)')) && !bg.includes('.webp') && !bg.includes('cdninstagram')) {
                bg = `${bg}.webp`;
                element.setAttribute('data-bg', bg);
            }
        });
    }

    /* lazy load  ++++++++++++++++++++++++++++++++++++++++++*/
    dataStore.lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy'
    });

    /* lazy load  ++++++++++++++++++++++++++++++++++++++++++*/
    dataStore.lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy',
        callback_loaded: () => {
            masonryUpdate();
        }
    });

    lazyloadUpdate();
})();
/* eslint-disable */
// #################################################
// ######### Products Table Ajax Functions #########
// #################################################

// Remove all Cart Items
function clearCart(){
    var obj = {
        items: []
    };
    dataStore.cartItems = JSON.stringify(obj);
    localStorage.setItem('cartItems', dataStore.cartItems);
    updateCartBtn();
}

// Watch list get Updated
function updateWatchListBtn() {
    var obj = JSON.parse(dataStore.watchlistItems);
    if(obj != null) {
        var numPosts = obj.items.length;
        dataStore.productsNum.text(numPosts);
    }
}

// Cart get updated
function updateCartBtn() {
    // console.log('updateCartBtn');
    var obj = JSON.parse(dataStore.cartItems);
    if(obj != null) {
        var numPosts = 0;
        for(let i = 0; i < obj.items.length; i++) {
           var thisItem = obj.items[i];
           numPosts = numPosts+thisItem.quantity;
        }
        // var numPosts = obj.items.length;
        dataStore.cartProductsNum.text(numPosts);
    }
}

// Change Add Button Classes
function setButtonClasses() {
    if(dataStore.productsTable.length){
        var obj = JSON.parse(dataStore.watchlistItems);
        if(obj != null) {
            for(let i = 0; i < obj.items.length; i++) {
                var thisItem = obj.items[i],
                    thisId = thisItem.postID;
                $('.addToList[data-postid='+thisId+']').addClass('inList');
            }
        }
    }
}

// Remove Item from Watchlist
function removeFromWatchList(currentObj,postID) {
    var obj = currentObj;
    for(let i = 0; i < currentObj.items.length; i++) {
        if( currentObj.items[i].postID == postID ) {
            obj.items.splice(i,1);
            break;
        }
    }
    return obj;
}

// Set Local Storage Values
function setStroageVal(obj) {
    var jsonObjct = JSON.stringify(obj);
    localStorage.setItem('watchListItems',jsonObjct);
    dataStore.watchlistItems = localStorage.getItem('watchListItems');
}

// Set Cart Local Storage Values
function setCartVal(obj) {
    var jsonObjct = JSON.stringify(obj);
    localStorage.setItem('cartItems',jsonObjct);
    dataStore.cartItems = localStorage.getItem('cartItems');
}

// Add List Products Input Field
function writeToInputField(type) {
    if(type === 'b2bCart'){
        var tmpList = dataStore.cartItems;
    } else {
        var tmpList = dataStore.watchlistItems;
    }
    if(tmpList != null) {
        var obj = JSON.parse(tmpList),
            itemsString = '',
            itemSeperator = ', ';
        for(let i = 0; i < obj.items.length; i++) {
            if(i+1 == obj.items.length) {
                itemSeperator = '';
            }
            itemsString = itemsString + obj.items[i].postNr + itemSeperator;
        }
        $('#productsField').val(itemsString);
    }
}


// No Products TR
function noPostsMessage(oneShown, colspan) {
    //------------------------ Meldung anzeigen/entfernen ------------------------
    if(!oneShown) {
        if($('.noPostsFound').length == 0) {
            var noPostsMessageText = dataStore.productsTable.data('message');
            $('.productsTableContainer').append(
                '<div class="noPostsFound d-lg-flex justify-content-lg-between">'+noPostsMessageText+'</div>'
            );
        }
    }else{
        $('.noPostsFound').remove();
    }
}

/*
    B2B
 */

/* B2B Rechner */
$(document).on('keyup', '.b2b .quantity', function(e){
    changeSets($(e.currentTarget));
    spinnerNotification($(e.currentTarget));
    if(parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bCart){
        changeQuantity($(e.currentTarget));
    }
});

// Change Product Quantity
$(document).on('click', '.ui-spinner-button', function(e){
    changeSets($(e.currentTarget));
    spinnerNotification($(e.currentTarget).siblings('.quantity'));
    if(parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bCart){        
        changeQuantity($(e.currentTarget));
    }
});

// Wird im Cart aufgerufen, wenn quantity verändert wird
function changeQuantity(_this){
    var thisLink = $(_this),
    tempObject = {
        'postID': parseInt(thisLink.closest('.postItem').attr('data-postid')),
        'postTitle': thisLink.closest('.postItem').attr('data-posttitle'),
        'postNr': thisLink.closest('.postItem').attr('data-postartnr'),
        'quantity': parseInt(_this.closest('.postItem').find('.quantity').val()),
        'preorder': parseInt(_this.closest('.postItem').attr('data-preorder'))
    },
    currentObj = JSON.parse(dataStore.cartItems);

    if(currentObj != null) {
        // wenn bereits daten im local storage waren
        // vorhandenes Produkt hochzähöen
        var found = false;
        for(var a = 0, aLen = currentObj.items.length; a < aLen; a++){
            if(currentObj.items[a].postID == tempObject.postID && currentObj.items[a].preorder === tempObject.preorder) {
                currentObj.items[a].quantity = parseInt(tempObject.quantity);
                found = true;
                break;
            }
        }
        var obj = currentObj;
        if(!found){
            obj.items.push(tempObject);
        }

    }

    setCartVal(obj);
    updateCartBtn();
}

// Change Product Sets Quantity
function changeSets(_this){
    var setId = _this.closest('.postItem').attr('data-setid');
    if(setId.length !== 0){
        $('.postItem[data-setid='+setId+'] .quantity').val(_this.closest('.postItem').find('.quantity').val());
    }
}

/* B2B Coupon */
var gutscheinbetrag = 0;
$('.b2bFormWrap input[name="apply_coupon"]').click(function(event) {
    var form = $('.b2bFormWrap');
    event.preventDefault();

    var data = {
        b2bCouponCode: form.find( 'input[name="b2bCouponCode"]' ).val()
    };

    $.ajax({
        url : window.wp_urls.homeUrl,
        type : 'POST',
        data: data,
        success : function(code) {
            var obj = JSON.parse(code);

            if(obj.result){
                gutscheinbetrag = obj.msg.gutscheinbetrag;
                dataStore.gutschein_type = obj.msg.gutschein_type;

                calculateOrderCosts();
                $("input[name='couponId']").val(obj.msg.couponId);
                $('.coupon').removeClass('hide');
                form.hide();
                $('.msg').addClass('hide');
            } else {
                $('.msg').removeClass('hide').addClass('error').text(obj.msg);
            }
        },
        error : function() {
            alert("Es ist ein Fehler aufgetreten.");
        }
    });

});

// Wird für den Checkout benutzt
(function ($) {
    $.fn.serializeFormJSON = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
})(jQuery);

// Checkout Submit Button
$('.checkout').submit(function(event) {
    var $form = $(this);
    event.preventDefault();

    var data = $form.serializeFormJSON();
    $.ajax({
        url : window.wp_urls.homeUrl,
        type : 'POST',
        data: data,
        success : function(code) {
            var obj = JSON.parse(code);
            if(obj.result){
                $('.msg').removeClass('hide').removeClass('error').addClass('success').text(obj.msg);

                $('.warenkorb article').hide();
                $('.shippingInfo').hide();
                $('.totalTable').hide();
                $('.orderFormWrap').hide();
                $('#productsContainer').hide();
                $("html, body").scrollTop(0);

                clearCart();
            } else {
                $('.msg').removeClass('hide').addClass('error').text(obj.msg);
            }
        },
        error : function() {
            alert("Es ist ein Fehler aufgetreten.");
        }
    });

});

// On Login Submit get loader
$('#loginform').on('submit', function(){
    $('.loader').removeClass('hide');
});

// Calculate Order Costs in b2b Cart
function calculateOrderCosts(){
    var subtotal = 0,
    totalAmount = 0,
    subtotalCoupon = 0;

    $.each($('.quantity'), function(key, value){
        subtotal = subtotal + parseFloat($(value).attr('data-lineAmount'));
    });

    if(gutscheinbetrag != 0){

        subtotalCoupon = (subtotal / 100 * gutscheinbetrag);
        if (dataStore.gutschein_type === 'fixedAmount') {
            subtotalCoupon = gutscheinbetrag;
        }

        $('.subtotalCoupon').html('- '+number_format(subtotalCoupon, 2, ',', '.')+' &euro;');
    }

    if(subtotal != 0){
        totalAmount = (parseFloat(subtotal) - parseFloat(subtotalCoupon));
    } else {
        totalAmount = 0;
    }

    $('.subtotal').html(number_format(subtotal, 2, ',', '.')+' &euro;');
    $('.subtotal').attr('data-subtotal', number_format(subtotal, 2, ',', '.'));
    $("input[name='subtotal']").val(subtotal);
    $('.totalAmount').html(number_format(totalAmount, 2, ',', '.')+' &euro;');
}



// Init UI Spinner on B2B Cart & B2b Shop
function initSpinner(){
    $('.quantity').spinner({
        icons: { 
            down: "icon-chevron-down", 
            up: "icon-chevron-up" 
        }
    });
    $('.quantity').each(function(i,el){
        if($(el).is(':disabled')){
            $(el).spinner( "disable" );
        }
    });
}


//Spinner notification if Quantity is over max Val
function spinnerNotification(this_){
    var maxVal = parseInt(this_.attr('max')),
        currentVal = parseInt(this_.val()),
        setId = this_.closest('.postItem').attr('data-setid'),
        allQuantities;

    if (currentVal >= maxVal) {
        if(setId.length === 0){
            $(this_).val(maxVal);
        }else{
            $('.postItem[data-setid='+setId+'] .quantity').val(maxVal);
        }

        this_.parent().parent().find('.noticeMessage').removeClass('faded');
        setTimeout(function(){
            this_.parent().parent().find('.noticeMessage').addClass('faded');
        }, 7000);
    }


    if (currentVal > 0) {
        this_.parent().parent().parent().find('.addToCart').removeClass('isDisabled');
    }else if(currentVal === 0){
        this_.parent().parent().parent().find('.addToCart').addClass('isDisabled');
    }

    if(setId.length !== 0){
        // Berechnung der Sets
        allQuantities = $('.postItem[data-setid='+setId+'] .quantity');
    }else {
        allQuantities = this_;
    }

    for(var a = 0, aLen = allQuantities.length; a<aLen; a++){
        this_ = allQuantities[a];

        this_ = $(this_);

        var lineAmount = this_.attr('data-price') * this_.val();
        this_.attr('data-lineAmount', lineAmount);
        this_.closest('tr').find('.lineAmount').html(number_format(lineAmount, 2, ',', '.')+' &euro;');

        if(parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bCart){
            calculateOrderCosts();
        }
    }

}


// Explode Effect on add to cart button
// function explode(e) {

//     if ($('#scrollHeader').hasClass('fix')) {
//         var x = $('#scrollHeader #cartIcon').offset().left;
//         var y = $('#scrollHeader #cartIcon').offset().top;
//     }else{
//         var x = $('.header #cartIcon').offset().left;
//         var y = $('.header #cartIcon').offset().top;
//     }

//     var c = document.createElement('canvas')
//     var ctx = c.getContext('2d')
//     var ratio = window.devicePixelRatio
//     var particles = []

//     document.body.appendChild(c)
//     c.style.position = 'absolute'
//     c.style.zIndex = '1001'
//     c.style.left = (x - 90) + 'px'
//     c.style.top = (y - 90) + 'px'
//     c.style.pointerEvents = 'none'
//     c.style.width = 200 + 'px'
//     c.style.height = 200 + 'px'
//     c.width = 200 * ratio
//     c.height = 200 * ratio

//     function Particle() {
//         return {
//             x: c.width / 2,
//             y: c.height / 2,
//             radius: r(20,30),
//             color: 'rgb(' + [r(0,255), r(0,255), r(0,255)].join(',') + ')',
//             rotation: r(0,360, true),
//             speed: r(8,12),
//             friction: 0.9,
//             opacity: r(0,0.5, true),
//             yVel: 0,
//             gravity: 0.1
//         }
//     }

//     for(var i=0; ++i<25;) {
//         particles.push(Particle())
//     }

//     function render() {
//         ctx.clearRect(0, 0, c.width, c.height)
//         particles.forEach(function(p, i) {
//             angleTools.moveOnAngle(p, p.speed)
//             p.opacity -= 0.01
//             p.speed *= p.friction
//             p.radius *= p.friction
//             p.yVel += p.gravity
//             p.y += p.yVel
//             if(p.opacity < 0) return
//             if(p.radius < 0) return
//             ctx.beginPath()
//             ctx.globalAlpha = p.opacity
//             ctx.fillStyle = p.color
//             ctx.arc(p.x, p.y, p.radius, 0, 2 * Math.PI, false)
//             ctx.fill()
//         })
//     }

//     ;(function renderLoop(){
//         requestAnimationFrame(renderLoop)
//         render()
//     })()

//     setTimeout(function() {
//         document.body.removeChild(c)
//     }, 3000)
// }

var angleTools={getAngle:function(t,n){var a=n.x-t.x,e=n.y-t.y;return Math.atan2(e,a)/Math.PI*180},getDistance:function(t,n){var a=t.x-n.x,e=t.y-n.y;return Math.sqrt(a*a+e*e)},moveOnAngle:function(t,n){var a=this.getOneFrameDistance(t,n);t.x+=a.x,t.y+=a.y},getOneFrameDistance:function(t,n){return{x:n*Math.cos(t.rotation*Math.PI/180),y:n*Math.sin(t.rotation*Math.PI/180)}}};
function r(a,b,c){ return parseFloat((Math.random()*((a?a:1)-(b?b:0))+(b?b:0)).toFixed(c?c:0)); }



// ################ JSON PRDUCTS FUNCTIONS ################
var jsonUrl = '', output = '',perPage = 20, alternativBild = '', thumbUrl = '', classItem = '', videos = '', classes = '', theTitle = '', bauform = '', bestand = '', bestandCls = 'status3', bestandTxt = '', quantityDisabled = '', quantityHidden = '',
    notAvailableIcon = '<span class="icon-x-circle"></span>',
    availableIcon = '<span class="icon-check-circle"></span>',
    littleAvailableIcon = '<span class="icon-alert-circle"></span>',
    bestandIcon = notAvailableIcon, isSingle = false, showAddButton = true, kaliber_mm = '', schuss = '', vk = '', stve = '', stkPreis = '', vkRabatt = '', normalPrice = '', discountPrice = '', discountVk = '', normalVk = '', paged = 1, setid = '',
    artnr = '', lastPost = '', hot_offer = 0, productDiscount = 0, lineamount = 0, lineamountValue = 0, quantity = 0, price = 0;

var preorder = 0, preorderDiscount = 0, preorderWareneingang = 0;

//  ######   Get Product Table Column Function   ######
function tableAboutColumn(e, preorder){

    // console.log('preorder start');
    // console.log(preorder);

    if(e.featured_media != 0){
        thumbUrl = e.thumb.small;
    } else if(e.acf !== undefined && e.acf.alternativBild !== undefined) {
        thumbUrl = e.acf.alternativBild.sizes.small;
    } else {
        thumbUrl = window.wp_urls.template_dir + '/assets/img/produktPlaceholder.jpg';
    }

    if(e.acf !== undefined && e.acf.videos !== undefined && e.acf.videos !== false) {
        videos = e.acf.videos;
        var videosUrl = videos[0].url;
    }

    classes = 'imgWrap';
    if(videos.length) {
        classes = 'imgWrap hasVids';
    }

    if(parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bShop || parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart){

        if(e.acf !== undefined && e.acf.bestand !== undefined) {
            bestand = e.acf.bestand;
        }

        
        if(bestand !== '') {
            if(bestand == 0){
                bestandCls = 'status3';

                if(window.wp_urls.language == 'de') {
                    bestandTxt = 'demnächst wieder verfügbar';    
                } else {
                    bestandTxt = 'available again soon';    
                }

                bestandIcon = notAvailableIcon;
                quantityDisabled = 'disabled';
                quantityHidden = 'style="display:none"';
            }
            if(bestand > 0 && bestand <= 10){
                bestandCls = 'status2';

                if(window.wp_urls.language == 'de') {
                    bestandTxt = 'geringer Lagerbestand';    
                } else {
                    bestandTxt = 'low inventory stock';    
                }

                bestandIcon = littleAvailableIcon;
            }
            if(bestand > 10){
                bestandCls = 'status1';

                if(window.wp_urls.language == 'de') {
                    bestandTxt = 'sofort verfügbar';    
                } else {
                    bestandTxt = 'available';    
                }

                bestandIcon = availableIcon;
            }
        }
        // console.log('preorder 1');
        // console.log(preorder);

        // PREORDER
        let hash = '';
        if (window.location.hash) {
            hash = window.location.hash.substr(1);
        }
        hot_offer = 0;

        let preorderDiscount = 0;

        if(hash == 'preorder' || preorder === 1) {
            if(e.acf.preorder !== undefined && parseInt(e.acf.preorder) == 1) {              

                if(e.acf.hot_offer !== undefined && parseInt(e.acf.hot_offer) > 0) {
                    dataStore.isPreorderProduct = true;
                    preorderDiscount = e.acf.hot_offer;
                    preorder = e.acf.preorder;
                    preorderWareneingang = e.acf.preorderWareneingang;
                    bestandCls = 'status2';

                    if (preorderWareneingang !== 0) {

                        if(window.wp_urls.language == 'de') {
                            bestandTxt = 'Preorder (verfügbar ab ca. ' + preorderWareneingang + ')';
                        } else {  
                            bestandTxt = 'Preorder (available from ca. ' + preorderWareneingang + ')';
                        }

                    } else {
                        bestandTxt = 'Preorder';
                    }
                    
                    bestandIcon = littleAvailableIcon;      
                    bestand = 99999999;
                    hot_offer = e.acf.hot_offer;                
                } else {
                    preorder = 0;
                    dataStore.isPreorderProduct = false;
                }
            }
        }
    }
    // console.log('preorder 2');
    // console.log(preorder);

    let inList = '';
    var listObj = JSON.parse(dataStore.watchlistItems);

    if(listObj !== null && listObj.items.length) {
        for(let i = 0; i < listObj.items.length; i++) {
            if( listObj.items[i].postID == e.id ) {
                inList = 'inList';        
                break;
            }
        }
    }

    var addToListBtnTmpFilled = '';
    if(parseInt(window.wp_urls.pageID) !== dataStore.globalIds.watchList){
        var addToListBtnTmp = returnTemplate('addToListBtn.html'),
            addToListBtnTmpData = {
                id : e.id,
                title : e.title.rendered,
                artnr : e.acf.artnr,
                isB2b : parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bShop || parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
                isB2bCart : parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
                showButton : false,
                addToWatchlist: window.wp_urls.textBlocks.addToWatchlist,
                removeFromWatchlist: window.wp_urls.textBlocks.removeFromWatchlist,
                inList: inList
            },
            addToListBtnTmpFilled  = Mustache.to_html(addToListBtnTmp, addToListBtnTmpData);
    }

    
    let color = '#9CA3AF';

    if($(`[data-cat="${e.cat.slug}"]`).length) {
        const cat = $(`[data-cat="${e.cat.slug}"]`);

        let currentColor;

        if(cat.hasClass('mainCat')) {
            currentColor = cat.data('color');            
        }else{
            currentColor = cat.closest('.mainCat').data('color');
        }

        if(currentColor !== '') {
            color = currentColor;
        }
    }
    
    if (dataStore.isPreorderProduct == true ) {
        const bestand = 99999999;
    } else {
        const bestand = e.acf.bestand;
    }    

    var tableAboutColumnTmp = returnTemplate('tableAboutColumn.html'),
        tableAboutColumnTmpData = {
            id : e.id,
            title : e.title.rendered,
            link : e.link,
            excerpt : e.excerpt,
            artnr : e.acf.artnr,
            bauform : e.acf.bauform,
            bestand : bestand,
            slug : e.slug,
            catSlug : e.cat.slug,
            catName : e.cat.name,
            catColor: color,
            productSet : e.productSet,
            bestandCls : bestandCls,
            bestandTxt : bestandTxt,
            bestandIcon : bestandIcon,
            quantityDisabled : quantityDisabled,
            quantityHidden : quantityHidden,
            thumbUrl : thumbUrl,
            isntB2b : parseInt(window.wp_urls.pageID) !== dataStore.globalIds.b2bShop || parseInt(window.wp_urls.pageID) !== dataStore.globalIds.b2bCart,
            isB2b : parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bShop || parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
            isB2bCart : parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
            classes : classes,
            videos : videos,
            videosUrl : videosUrl,
            btnTemplate : addToListBtnTmpFilled,
            hot_offer : hot_offer,
            more : window.wp_urls.textBlocks.more,
            offer : window.wp_urls.textBlocks.offer,
            category : window.wp_urls.textBlocks.category,
            itemNo : window.wp_urls.textBlocks.itemNo,
            style : window.wp_urls.textBlocks.style,
            productsBundle : window.wp_urls.textBlocks.productsBundle,
            preorder: preorder,
            preorderDiscount: preorderDiscount
        },
        tableAboutColumnTmpFilled  = Mustache.to_html(tableAboutColumnTmp, tableAboutColumnTmpData);

    output = tableAboutColumnTmpFilled;

    return output;
}


// Get Products from Rest Api Json - Function
function getJsonProducts(term){
    if($('.page-template-template-b2b_order_table #productsTable, .post-type-archive-products #productsTable, .single-products #productsTable').length && dataStore.productsTableIsLoading === false && dataStore.productsTableEnd === false || dataStore.productListLocation === 'b2bCart' && dataStore.productsTableIsLoading === false && dataStore.productsTableEnd === false || dataStore.productListLocation === 'watchList' && dataStore.productsTableIsLoading === false && dataStore.productsTableEnd === false){

        $('#productsTableWrap .loaderWrap').fadeIn('300');
        dataStore.productsTableIsLoading = true;
        $('.dataTables_empty').remove();

        if(dataStore.productsTableSearch){
            jsonUrl = window.wp_urls.baseUrl+'/wp-json/wp/v2/products?filter[taxonomy]=productCat&search='+dataStore.productsTableSearch+'&per_page='+perPage+'&page='+paged;
        }else if(dataStore.productListLocation === 'singleProduct'){
            dataStore.productsTableEnd = true;

            var postId = window.wp_urls.pageID;
            jsonUrl = window.wp_urls.baseUrl+'/wp-json/wp/v2/products/'+postId;

        } else if(dataStore.productListLocation === 'watchList' || dataStore.productListLocation === 'b2bCart'){
            dataStore.productsTableEnd = true;

            var listObj = JSON.parse(dataStore.watchlistItems);
            if(dataStore.productListLocation === 'b2bCart'){
                listObj =  JSON.parse(dataStore.cartItems);
            }

            if(listObj !== null && listObj.items.length > 0){
            jsonUrl = window.wp_urls.baseUrl+'/wp-json/wp/v2/products';
                $.each(listObj.items, function(i, e) {
                    var seperator = '?';
                    if(i != 0){
                        seperator = '&';
                    }
                    jsonUrl += seperator+'include[]='+e.postID
                    jsonUrl += '&per_page=100';
                });
            } else {
                noPostsMessage(false, 5);
            }

        } else {
            jsonUrl = window.wp_urls.baseUrl+'/wp-json/wp/v2/products?filter[taxonomy]=productCat'+term+'&filter[meta_key]=lagerplatz&filter[orderby]=meta_value&order=asc&per_page='+perPage+'&page='+paged;
        }
        dataStore.outputIndex = 0;
        $.getJSON(jsonUrl, function (data) {
            if(data.length < perPage) {
                dataStore.productsTableEnd = true;
            }

            if(typeof data !== 'undefined' && !isEmpty(data)){

                lastPost = dataStore.body.scrollTop();

                $(data).each(function(i,e){

                    if(e.acf !== undefined && e.acf.vk !== undefined) {
                        vk = e.acf.vk;
                    }

                    if(e.acf !== undefined && e.acf.stve !== undefined) {
                        stve = e.acf.stve;
                    }

                    if(e.acf !== undefined && e.acf.bestand !== undefined) {
                        bestand = e.acf.bestand;
                    }
                    if(parseInt(dataStore.discount) > 0) {
                        productDiscount = dataStore.discount;
                    }

                    // console.log('');
                    // console.log('Neues Produkt');
                    // console.log('e.acf.kein_rabatt', e.acf.kein_rabatt);
                    // console.log('productDiscount', productDiscount);
                    // console.log('discountPrice', discountPrice);

                    if(e.acf !== undefined && e.acf.kein_rabatt == false && productDiscount !== ''){
                        // console.log(' rabatt anwenden 1');
                        vkRabatt = vk - (vk * productDiscount / 100);
                        stkPreis = vkRabatt/stve;
                        normalPrice = number_format(vk/stve, 2, ',', '.');
                        discountPrice = number_format(stkPreis, 2, ',', '.');
                    } else {
                        stkPreis = vk/stve;
                        normalPrice = number_format(stkPreis, 2, ',', '.');
                        // console.log(' keinen rabatt anwenden 1');

                        if(e.acf !== undefined && e.acf.kein_rabatt == true) {
                            discountPrice = 0;
                            vkRabatt = '';
                            discountVk = '';
                        }
                    }

                    if(discountPrice === normalPrice){
                        discountPrice = 0;
                    }

                    if(vk !== '') {
                        if(e.acf !== undefined && vkRabatt !== '' && e.acf.kein_rabatt == false){
                            // console.log('hier 1.1');
                            discountVk = number_format(vkRabatt, 2, ',', '.');
                            normalVk = number_format(vk, 2, ',', '.');
                        } else {
                            normalVk = number_format(vk, 2, ',', '.');
                            // console.log('hier 1.2');
                        }
                        if(discountVk === normalVk){
                            discountVk = 0;
                            // console.log('hier 1.3');
                        }
                    }

                    if(bestand !== '' && parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bShop || bestand !== '' && parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart) {
                        if(bestand == 0){
                            quantityDisabled = 'disabled';
                            quantityHidden = 'style="display:none"';
                        } else {
                            quantityDisabled = '';
                            quantityHidden = '';
                        }
                    }

                    if(e.acf !== undefined && e['acf']['set-id'] !== undefined){
                        setid = e['acf']['set-id'];
                    } else {
                        setid = '';
                    }

                    

                    if(dataStore.productListLocation === 'b2bCart'){
                        listObj =  JSON.parse(dataStore.cartItems);
                    }

                    if(dataStore.productListLocation === 'b2bCart' && listObj !== null && listObj.items.length > 0){
                        // console.log('hier 1');
                        $.each(listObj.items, function(listObjIndex, listObjEl) {
                            if(e.acf !== undefined && vkRabatt !== '' && e.acf.kein_rabatt == false){
                                price = vkRabatt;
                                // console.log('hier 2');
                            } else {
                                price = vk;
                                // console.log('hier 3');
                            }
                            if(e.id === listObjEl.postID){
                                quantity = listObjEl.quantity                                
                                // Check if quanitity is heigher then bestand
                                if(quantity > bestand){
                                    quantity = bestand;
                                }
                                lineamount = price * quantity;
                                lineamountValue = number_format(lineamount, 2, ',', '.');

                                // Für Preorder Produkte Bestand ignorieren und Rabatt hinzufügen

                                if (listObjEl.preorder == true) {
                                    bestand = 99999999;
                                    quantityDisabled = '';
                                    quantityHidden = '';
                                    quantity = listObjEl.quantity;
                                    preorder = 1;

                                    // Preorder Preis neu berechnen mit Preorder Discount ohne user Discount
                                    if(e.acf !== undefined && e.acf.kein_rabatt == false && e.acf.hot_offer > 0){
                                        // console.log('hier 4');
                                        preorderDiscount = e.acf.hot_offer;
                                        vkRabatt = vk - (vk * preorderDiscount / 100);
                                        stkPreis = vkRabatt/stve;
                                        normalPrice = number_format(vk/stve, 2, ',', '.');
                                        discountPrice = number_format(stkPreis, 2, ',', '.');
                                        
                                        if(vk !== '') {
                                            if(e.acf !== undefined && vkRabatt !== '' && e.acf.kein_rabatt == false){
                                                discountVk = number_format(vkRabatt, 2, ',', '.');
                                                normalVk = number_format(vk, 2, ',', '.');
                                                // console.log('2.1');
                                            } else {
                                                normalVk = number_format(vk, 2, ',', '.');
                                                // console.log('2.2');
                                            }
                                            if(discountVk === normalVk){
                                                discountVk = 0;
                                                // console.log('2.3');
                                            }

                                            if(e.acf !== undefined && vkRabatt !== '' && e.acf.kein_rabatt == false){
                                                price = vkRabatt;
                                            } else {
                                                price = vk;
                                            }

                                            lineamount = price * quantity;
                                            lineamountValue = number_format(lineamount, 2, ',', '.');
                                        }
                                    }

                                } else {
                                    preorder = 0;
                                }
                            }                                                
                        });
                    }

                    
                    let inList = '';
                    var watchlistItems = JSON.parse(dataStore.watchlistItems);

                    if(watchlistItems !== null && watchlistItems.items.length) {
                        for(let i = 0; i < watchlistItems.items.length; i++) {
                            if( watchlistItems.items[i].postID == e.id ) {
                                inList = 'inList';        
                                break;
                            }
                        }
                    }

                    var addToListBtnTmpFilled = '';
                    if(parseInt(wp_urls.pageID) !== dataStore.globalIds.watchList){
                        var addToListBtnTmp = returnTemplate('addToListBtn.html'),
                            addToListBtnTmpData = {
                                id : e.id,
                                title : e.title.rendered,
                                artnr : e.acf.artnr,
                                isB2b : parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bShop || parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
                                isB2bCart : parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
                                isSingle : dataStore.singleProducts,
                                showButton : true,
                                addToWatchlist: window.wp_urls.textBlocks.addToWatchlist,
                                removeFromWatchlist: window.wp_urls.textBlocks.removeFromWatchlist,
                                inList: inList
                                
                            },
                            addToListBtnTmpFilled = Mustache.to_html(addToListBtnTmp, addToListBtnTmpData);
                    }


                    if(dataStore.productListLocation !== 'b2bCart'){
                        let hash = '';
                        if (window.location.hash) {
                            hash = window.location.hash.substr(1);
                        }

                        if(e.acf.preorder !== undefined && parseInt(e.acf.preorder) == 1 && hash == 'preorder') {                                  
                            bestand = 99999999;
                            quantityDisabled = '';
                            quantityHidden = '';
                            preorder = 1;

                            // Preorder Preis neu berechnen mit Preorder Discount ohne user Discount
                            if(e.acf !== undefined && e.acf.kein_rabatt == false && e.acf.hot_offer > 0){
                                preorderDiscount = e.acf.hot_offer;
                                vkRabatt = vk - (vk * preorderDiscount / 100);
                                stkPreis = vkRabatt/stve;
                                normalPrice = number_format(vk/stve, 2, ',', '.');
                                discountPrice = number_format(stkPreis, 2, ',', '.');

                                if(vk !== '') {
                                    if(e.acf !== undefined && vkRabatt !== '' && e.acf.kein_rabatt == false){
                                        discountVk = number_format(vkRabatt, 2, ',', '.');
                                        normalVk = number_format(vk, 2, ',', '.');                                        
                                    } else {
                                        normalVk = number_format(vk, 2, ',', '.');
                                    }
                                    if(discountVk === normalVk){
                                        discountVk = 0;
                                    }
                                }
                            }
                        } else {
                            bestand = e.acf.bestand;
                            preorder = 0;
                        }
                    }

                    // console.log('normalPrice', normalPrice);
                    // console.log('discountPrice', discountPrice);
                    // console.log('vkRabatt', vkRabatt);
                    // console.log('normalVk', normalVk);
                    // console.log('discountVk', discountVk);

                    var tableInfoColumnsTmp = returnTemplate('tableInfoColumns.html'),
                        tableInfoColumnsTmpData = {
                            setid : e['acf']['set-id'],
                            parentSlug : e.parent.slug,
                            catSlug : e.cat.slug,
                            catName : e.cat.name,
                            kaliber_mm : e.acf.kaliber_mm,
                            schuss : e.acf.schuss,
                            bauform : e.acf.bauform,
                            discountPrice : discountPrice,
                            normalPrice : normalPrice,
                            normalVk : normalVk,
                            discountVk : discountVk,
                            stve : e.acf.stve,
                            bestand : bestand,
                            quantityDisabled : quantityDisabled,
                            quantityHidden : quantityHidden,
                            artnr : e.acf.artnr,
                            vkRabatt : vkRabatt,
                            vk : vk,
                            kein_rabatt : e.acf.kein_rabatt,
                            btnTemplate : addToListBtnTmpFilled,
                            isB2b : parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bShop || parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
                            isB2bCart : parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
                            isSingle : dataStore.singleProducts,
                            lineamount : lineamount,
                            lineamountValue : lineamountValue,
                            quantity : quantity,
                            isWatchCartList : parseInt(window.wp_urls.pageID) === dataStore.globalIds.watchList || parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart,
                            unfortunately : window.wp_urls.textBlocks.unfortunately,
                            available : window.wp_urls.textBlocks.available,
                            preorder: preorder,
                            preorderDiscount: preorderDiscount
                        },
                        tableInfoColumnsTmpFilled  = Mustache.to_html(tableInfoColumnsTmp, tableInfoColumnsTmpData);


                    // console.log('preorder als erstes');
                    // console.log(preorder);

                    // Alle Bestandteile Zusammensetzten
                    output = '<tr class="postItem filterEl" data-bestand="'+e.acf.bestand+'" data-postid="'+e.id+'" data-id="'+e.cat.slug+'" data-parent="'+e.parent.slug+'" data-cat="'+e.cat.name+'" data-setid="'+setid+'" data-preorder="'+preorder+'">';
                        if(dataStore.productListLocation !== 'singleProduct'){
                            output += tableAboutColumn(e, preorder, preorderDiscount);
                        }
                        output += tableInfoColumnsTmpFilled;
                    output += "</tr>";

                    $('#productsTable tbody').append(output);

                });
            } else {
                if(parseInt(window.wp_urls.pageID) !== dataStore.globalIds.b2bShop || parseInt(window.wp_urls.pageID) === dataStore.globalIds.b2bCart) {
                    $('#productsTable tbody').append('<tr class="odd"><td valign="top" colspan="4" class="dataTables_empty"><div class="inner"><span>Keine Produkte gefunden.</span></div></td></tr>');
                } else {
                    $('#productsTable tbody').append('<tr class="odd"><td valign="top" colspan="6" class="dataTables_empty"><div class="inner"><span>Keine Produkte gefunden.</span></div></td></tr>');
                }
                dataStore.productsTableEnd = true;
            }

        }).done(function() {

            // Scroll zu lettzen Position wenn neuer Inhalt kommt
            dataStore.body.scrollTop(lastPost);
            $('.postItem').not('.vis').each(function(i,e){
                setTimeout(function() {
                    $(e).addClass('vis');
                }, 50 + i);
            });

            // Initalization spinner
            initSpinner();

            // Add to Cart Action Explode
            // var anchors = $('.addToCart');
            // Array.prototype.forEach.call(anchors, function(anchor) {
            //     anchor.addEventListener('click', explode)
            // });            

            // Im B2B Cart Kosten Calculieren
            if(parseInt(window.wp_urls.pageID) == dataStore.globalIds.b2bCart){
                var tmpObj = JSON.parse(dataStore.cartItems);
                if (tmpObj != null) {
                    if(tmpObj.items.length > 0) {
                        calculateOrderCosts();
                        $('.totalTable').removeClass('hide');
                        $('.orderFormWrap').removeClass('hide');
                    }
                }
            }



            var type = 'b2bCart';
            if(dataStore.productListLocation === 'watchList'){
                type = 'watchList';
            }
            writeToInputField(type);
            updateCartBtn();

        }).fail(function() {

            dataStore.productsTableEnd = true;
            // console.log( "Page not found" );

        }).always(function() {

            // clear loader
            var loaderWrap = $('#productsTableWrap .loaderWrap');
            if(dataStore.productListLocation === 'singleProduct'){
                loaderWrap = $('.singleProductTable .loaderWrap');
            } else if(dataStore.productListLocation === 'watchList' || dataStore.productListLocation === 'b2bCart'){
                loaderWrap = $('#productsContainer .loaderWrap');
            }
            loaderWrap.fadeOut('300').removeClass('firstLoad');

            // get new products Table Height
            dataStore.productsTableHeight = dataStore.productsTable.height();

            // count Up Paged
            paged++;

            // timeout for Loading
            setTimeout(function(){
                dataStore.productsTableIsLoading = false;
            },100);

        });
    }
}

// Get Nonce Function um den User Discount zu erhalten
function getNonce() {
    $.ajax({
        cache: false,
        timeout: 8000,
        url: window.wp_urls.ajaxUrl,
        type: "POST",
        data: ({ action:'getNonce'})
    }).done(function(response) {

        dataStore.nonce = response.nonce;
        // Getting Discount from User
        $.getJSON(window.wp_urls.baseUrl+'/wp-json/wp/v2/users/me?_wpnonce='+dataStore.nonce+'', function (data) {
            dataStore.discount = data.discount;
        }).fail(function() {
            // console.log( "Nonce not Found" );
        }).always(function() {
            getJsonProducts(dataStore.productsTableTerm);
        });

    });
}

// Get Json Products by Click (Filter)
function productsTableClick(filterCat){
    $('#productsTableWrap .loaderWrap').addClass('firstLoad');

    if(filterCat !== undefined && filterCat.length){
        dataStore.productsTableTerm = '&filter[term]='+filterCat;
    } else {
        dataStore.productsTableTerm = '';
    }
    paged = 1;
    $('tr.postItem').remove();
    dataStore.productsTableEnd = false;
    dataStore.productsTableIsLoading = false;
    getJsonProducts(dataStore.productsTableTerm);
}

// Add to Cart Function
function addToCart(this_, watchListObj, bestand){
    // console.log('addToCart');
    if(this_ !== false){        
        var thisLink = $(this_);
        var tempObject = {
            'postID': thisLink.data('postid'),
            'postTitle': thisLink.data('posttitle'),
            'postNr': thisLink.data('postartnr'),
            'quantity': + $('input[data-artnr="'+thisLink.data('postartnr')+'"]').val(),
            'preorder': thisLink.closest('.postItem').data('preorder')
        };
    } else {        
        var quantity = 1;
        
        if(bestand == 0 && watchListObj.preorder !== 1){
            quantity = 0;
        }
        var tempObject = {
            'postID': watchListObj.postID,
            'postTitle': watchListObj.postTitle,
            'postNr': watchListObj.postNr,
            'quantity': quantity,
            'preorder': watchListObj.preorder
        };
    }

    var currentObj = JSON.parse(dataStore.cartItems);

    if(currentObj != null) {
        // wenn bereits daten im local storage waren
        // vorhandenes Produkt hochzähöen
        var found = false;
        for(var a = 0, aLen = currentObj.items.length; a < aLen; a++){            
            if(currentObj.items[a].postID == tempObject.postID && currentObj.items[a].preorder === tempObject.preorder){
                currentObj.items[a].quantity += tempObject.quantity;
                found = true;
                break;
            }
        }

        var obj = currentObj;
        if(!found){
            obj.items.push(tempObject);
        }
    } else { // noch keine Daten vorhanden
        var obj= {
            items: []
        };
        obj.items.push(tempObject);
    }

    // Max Value neu setzen
    if(this_ !== false){
        $('input[data-artnr="'+thisLink.data('postartnr')+'"]').attr('max', parseInt($('input[data-artnr="'+thisLink.data('postartnr')+'"]').attr('max'))-tempObject.quantity);
    }

    setCartVal(obj);
    updateCartBtn();
}

// Manage Remove List Items
function manageRemoveList(this_){

    var thisLink = $(this_),
        parent = thisLink.closest('tr'),
        id = $(parent).data('postid');

    let currentObj;
    let type;

    if(thisLink.hasClass('removeFromCart')){
        currentObj = JSON.parse(dataStore.cartItems);
        type = 'b2bCart';
    } else {
        currentObj = JSON.parse(dataStore.watchlistItems);
        type = 'watchList';
    }

    const obj = removeFromWatchList(currentObj,id);

    if(thisLink.hasClass('removeFromCart')){
        setCartVal(obj);
        updateCartBtn();
    } else {
        setStroageVal(obj);
        updateWatchListBtn();
    }

    $(parent).remove();

    $('#watchListNotice').addClass('vis');

    writeToInputField(type);

    if(obj.items.length == 0) {
        // wenn letzten rausgeschmissen
        $('#productsContainer').empty();
        $('.orderFormWrap, .respond, .totalTable').hide();
        $('.noProducts').addClass('vis');
    }

    if(thisLink.hasClass('removeFromCart')){
        calculateOrderCosts();
    }

}

// ######### Products Table Ajax Functions ENDE


// #################################################
// ###########    Allgemeine Functions   ###########
// #################################################


/*
* Funktion die ein Template zurueck gibt. Wenn es schonmal geladen wurde aus dem templateStore.
* sonst erst laden, dort ablegen und den templateStore in den local storage legen
* uebergeben wird die url im templateordner. Name des Eintrages im Store = Name des Templates ohne .html
*/
function returnTemplate(url) {
    var toReturn,
        storeName = url.split('/');

    storeName = storeName[storeName.length - 1];
    storeName = storeName.split('.');
    storeName = storeName[0];

    if ( typeof(dataStore.templateStore[storeName]) === 'undefined' ) {
        // kein Eintrag = dieses Template wurde noch nicht geladen
        dataStore.templateStore[storeName] = false;

        $.ajax({
            url : window.wp_urls.template_dir + '/assets/template/' + url,
            cache : false,
            async : false
        }).done(function(tmpl) {
            dataStore.templateStore[storeName] = tmpl;
            var strTemplStore = JSON.stringify(dataStore.templateStore);
        });

        return dataStore.templateStore[storeName];

    } else {
        return dataStore.templateStore[storeName];
    }
}

// Check if Object is Empty
function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

// Change number formatation
function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + '')
    .replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function(n, prec) {
        var k = Math.pow(10, prec);
        return '' + (Math.round(n * k) / k)
        .toFixed(prec);
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
    .split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '')
    .length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1)
        .join('0');
    }
    return s.join(dec);
}

// Contact Form 7 Message Response
function wpcf7responseMessage(event){
    dataStore.wpcf7response.html('<p>'+event.detail.apiResponse.message+'</p>');
    dataStore.wpcf7response.removeClass('alert alert-danger alert-warning alert-success wpcf7-display-none');
}

function render_map( $el ) {
    var $markers = $el.find('.marker');
    var stylez = [
        {
            "featureType":"all",
            "elementType":"labels.text.fill",
            "stylers":[
                {"saturation":36},
                {"color":"#000000"},
                {"lightness":40}
            ]
        },
        {
            "featureType":"all",
            "elementType":"labels.text.stroke",
            "stylers":[
                {"visibility":"on"},
                {"color":"#000000"},
                {"lightness":16}
            ]
        },
        {
            "featureType":"all",
            "elementType":"labels.icon",
            "stylers":[
                {"visibility":"off"}
            ]
        },
        {
            "featureType":"administrative",
            "elementType":"geometry",
            "stylers":[
                {"color":"#616368"}
            ]
        },
        {
            "featureType":"landscape",
            "elementType":"geometry",
            "stylers":[
                {"color":"#222429"}
            ]
        },
        {
            "featureType":"poi",
            "elementType":"geometry",
            "stylers":[
                {"color":"#000000"},
                {"lightness":21}
            ]
        },
        {
            "featureType":"road.highway",
            "elementType":"geometry",
            "stylers":[
                {"color":"#313338"},
                {"weight":0.2}
            ]
        },
        {
            "featureType":"road.arterial",
            "elementType":"geometry",
            "stylers":[
                {"color":"#000000"},
                {"lightness":18}
            ]
        },
        {
            "featureType":"road.local",
            "elementType":"geometry",
            "stylers":[
                {"color":"#222429"},
                {"weight":0.1}
            ]
        },
        {
            "featureType":"transit",
            "elementType":"geometry",
            "stylers":[
                {"color":"#000000"},
                {"lightness":19}
            ]
        },
        {
            "featureType":"water",
            "elementType":"geometry",
            "stylers":[
                {"color":"#181A1F"}
            ]
        }
    ];

    var draggable;
    if ("ontouchend" in document) {
            draggable = false;
    }else{
        draggable = true;
    }

    var args = {
        zoom        : 10,
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        scrollwheel : false,
        draggable: draggable,
        streetViewControl: false,
        mapTypeControl: false,
        center      : new google.maps.LatLng(0, 0),
        mapTypeId   : google.maps.MapTypeId.ROADMAP,

        mapTypeControlOptions : {
            mapTypeIds : [google.maps.MapTypeId.ROADMAP, 'bestfromgoogle']
        }
    };

    // create map
    dataStore.map = new google.maps.Map( $el[0], args);

    var styledMapOptions = {
        name : "PyroProdukt"
    }

    var jayzMapType = new google.maps.StyledMapType(stylez, styledMapOptions);

    dataStore.map.mapTypes.set('bestfromgoogle', jayzMapType);
    dataStore.map.setMapTypeId('bestfromgoogle');

    dataStore.mapMarkers = [];

    // add markers
    $markers.each(function(){
        add_marker( $(this), dataStore.map );
    });

    // center map
    center_map( dataStore.map );
    // return
    //return map;

    $('.map').addClass('vis');

}

function add_marker( $marker, map ) {
    const latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    
    const icon = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 6,
        fillOpacity: 0,
        strokeWeight: 2,
        strokeColor: '#d7d000'
    };
        
    const marker = new google.maps.Marker({
        position    : latlng,
        map         : map,
        icon        : icon
    });

    dataStore.mapMarkers.push( marker );
    // if marker contains HTML, add it to an infoWindow
    // if( $marker.html() ) {
    //     // create info window
    //     var infowindow = new InfoBox({
    //         content     : $marker.html(),
    //         disableAutoPan  : false,
    //         maxWidth        : 230,
    //         pixelOffset         : new google.maps.Size(0, 0),
    //         alignBottom         : true,
    //         zIndex      : null,
    //         boxStyle        : {
    //             width : "230px"
    //         },
    //         closeBoxMargin  : "0",
    //         closeBoxURL         : "",
    //         infoBoxClearance    : new google.maps.Size(1, 1),
    //         enableEventPropagation: false
    //     });
    //     dataStore.infowindows.push(infowindow);
    // }

    // show info window when marker is clicked
    // google.maps.event.addListener(marker, 'click', function() {
    //     if(dataStore.infowindowOpen) {
    //         $(".mapTooltip").animate({opacity: 0},200);
    //         setTimeout(function() {
    //             closeInfoWindows();
    //             openInfoWindow(infowindow,map, marker);
    //         },200);
    //     }else{
    //         openInfoWindow(infowindow,map, marker);
    //     }
    // });
    // Bei Klick auf die Karte Infowindow schließen
    // google.maps.event.addListener(map, 'click', function() {

    //     // ausfaden
    //     $(".mapTooltip").animate({opacity: 0},200);

    //     // schließen
    //     setTimeout(function() {
    //         infowindow.close( map, marker );
    //     },200);

    //     dataStore.infowindowOpen = false;

    // });

    // if($marker.attr('data-showonstart')) {
    //     openInfoWindow(infowindow,map, marker,750);

    // }
}

function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( dataStore.mapMarkers, function( i, marker ){
        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
        bounds.extend( latlng );
    });

    // only 1 marker?
    if( dataStore.mapMarkers.length == 1 )
    {
        // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 16 );
    }
    else
    {
        // fit to bounds
        map.fitBounds( bounds );
    }

}

function openInfoWindow(infowindow,map, marker,delay) {
    var delay = delay || 100; //This sets bar to 100 if it's not already set

    // oeffnen
    infowindow.open(map, marker);
    dataStore.infowindowOpen = true;

    // einfaden
    setTimeout(function() {
        $(".mapTooltip").animate({opacity: 1},200);
        setTimeout(function() {
            $(".mapTooltip").addClass('vis')
        },100);
    },delay);
}

// Schließt alle Info Felder, bevor ein neues geöffnet wird
function closeInfoWindows() {
    for (var i = 0; i < dataStore.infowindows.length; i++) {
        dataStore.infowindows[i].close();
    }
}
/* eslint-enable */

function animatebodymovin() {
    if (dataStore.hasAnim) {
        const maxFrames = dataStore.anim.totalFrames;
        const frame = (maxFrames / 100) * (dataStore.docScroll / (dataStore.animDuration / 100));
        dataStore.anim.goToAndStop(frame, true);
    }
}

// function addToListIconAnimation() {
//     $('.addToList').each((i, el) => {
//         const id = $(el).attr('id');
//         const icon = $(el).find('.icon').attr('id');
//         const iconSkipForward = document.getElementById(id);

//         const animationSkipForward = lottie.loadAnimation({
//             container: document.getElementById(icon),
//             renderer: 'svg',
//             loop: false,
//             autoplay: false,
//             animationData: heartAnimationData
//         });

//         iconSkipForward.addEventListener('click', () => {
//             let backwards = false;

//             if ($(el).hasClass('inList')) {
//                 backwards = true;
//             }

//             if (backwards === true) {
//                 console.log('backwards');
//                 animationSkipForward.playSegments([15, 0], true);
//             } else {
//                 console.log('forwards');
//                 animationSkipForward.playSegments([0, 15], true);
//             }
//         });
//     });
// }

function checkSticky() {
    if (dataStore.stickyWrap.length) {
        if (dataStore.stickyWrap.height() + 64 < dataStore.winHeight) {
            dataStore.stickyWrap.addClass('sticky');
        } else {
            dataStore.stickyWrap.removeClass('sticky');
        }
    }
}
